import { Container, Divider } from "@mantine/core";
import React from "react";

const DesignerChoice = () => {
  return (
    <Container className="my-20">
      {/* <p className="text-3xl font-bold mb-10 text-[#D8AE96] uppercase text-center">
        Designer Choice
      </p> */}
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="relative w-32 lg:w-60 mb-3 md:mb-0">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio10.jpg?alt=media&token=e0bc770e-aff6-4b69-9900-fffdfefc385e"
            alt=""
            className="w-32 h-52 lg:w-60 lg:h-96 object-cover object-center rounded-lg shadow-lg"
          />
          <img
            src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio13.jpg?alt=media&token=be2a75e0-c41f-4746-8307-4c41766d5118"
            alt=""
            className="w-20 h-28 lg:w-32 lg:h-52 object-cover object-center rounded-lg shadow-lg absolute bottom-2 right-[-60px] lg:right-[-100px]"
          />
        </div>
        <div className="">
          <h1 className="text-[#D8AE96] text-3xl font-bold">Designer Choice</h1>
          <h1 className="text-[#5eb0c6] text-sm">Combo Package</h1>
          <Divider className="mt-1" />
          <p className="text-sm text-gray-500 leading-8 tracking-widest mt-1">
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aliquam,
            fugit sequi? Perferendis atque in distinctio ratione maxime!
            Mollitia magni, omnis nihil itaque modi alias, obcaecati reiciendis
            perferendis in molestiae fuga.
          </p>
          <p className="text-2xl mt-5 text-gray-500">$1300</p>
        </div>
      </div>
    </Container>
  );
};

export default DesignerChoice;
